import React from 'react';
import {connect} from 'react-redux';
import _ from 'lodash';

import {default as Modal, withModal} from 'components/Modal';
import Button from 'components/Button';

import {isModalOpen, MODALS, selectModal} from 'ducks/modals';

import './styles.css';

const InformationModal = ({closeModal, isOpen, message, heading}: any) => {
  return (
    <Modal
      className="InformationModal"
      modalOverlayClassName="InformationModalOverlay"
      show={isOpen}
      type={Modal.EXTRA_SMALL}
      onClose={closeModal}>
      <Modal.Header heading={heading} />
      <Modal.Body>
        <div className="text">{message}</div>
      </Modal.Body>
      <Modal.Footer>
        <Button white onClick={closeModal}>
          Okay
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const mapStateToProps = state => {
  const modal = selectModal(state, MODALS.INFORMATION_MODAL);

  return {
    isOpen: isModalOpen(state, MODALS.INFORMATION_MODAL),
    message: _.get(modal, 'data.message'),
    heading: _.get(modal, 'data.heading')
  };
};

export default connect(mapStateToProps)(
  withModal(MODALS.INFORMATION_MODAL)(InformationModal)
);
